import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, OnInit, Output } from "@angular/core";
import { TableFilterProperties } from "@app/shared/model/action.model";
import { NgChanges } from "@app/shared/model/ng-changes.model";
import { SearchPayload } from "../clare-search/clare-search.component";

@Component({
    selector: "clare-list",
    templateUrl: "./clare-list.component.html",
    styleUrls: ["./clare-list.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ClareListComponent<T extends { id: number | string }> implements OnInit, OnChanges {
    @Input() title: string;
    @Input() columns: Record<string, string | string[][]>;
    @Input() source: T[];
    @Input() isLoading = true;
    @Input() initialQueryString = "";
    @Input() shouldHideSearch = false;
    @Input() placeholder = "";

    @Output() editHandler = new EventEmitter<number | string>();
    @Output() changeFilterHandler = new EventEmitter<Partial<TableFilterProperties>>();

    public spinnerText: string;
    public columnArray: string[];
    public listStructure; // string[][]

    /**
     * @description Emits a value when a list item is clicked
     * @param {string} id the ID of the item clicked
     */
    public onEditClick(id: number | string) {
        this.editHandler.emit(id);
    }

    ngOnInit() {
        this.spinnerText = "Loading " + this.title;
        this.setColumnArray();
    }

    ngOnChanges(changes: NgChanges<ClareListComponent<T>>) {
        if (changes.columns) {
            this.setColumnArray();
        }
    }

    /**
     * @description Sets the column array given the current list structure
     * @private
     */
    private setColumnArray() {
        if (this.columns) {
            this.listStructure = this.columns._listStructure;
            const columns = { ...this.columns };
            delete columns._listStructure;
            this.columnArray = Object.keys(columns || {});
        } else {
            this.columnArray = [];
        }
    }

    /**
     * @description Determines whether the item is an object or not
     * @param {*} item the item to check
     * @returns {boolean} is the item an object?
     */
    public isObject(item: T): boolean {
        return typeof item === "object" && item !== null;
    }

    /**
     * @description Emits the prepared search term to the parent component
     * @param {SearchPayload} searchTerm the term to search in object form
     */
    public onDataSearch(searchTerm: SearchPayload) {
        this.changeFilterHandler.emit(searchTerm);
    }
}
